"use strict";
export const SafetyMock = (mock) => {
  mock.onGet("/v7/application_list").reply((config) => {
    let _response = {
      "model": "grid",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "authorize.application.detail",
            "application_guid": "application_e55a8e1419c5451ca99c2ff22d3bab00",
            "device_code": "0fdee151c5a3eb48d15ddf2152d4aa9a",
            "device_name": "windows-x64_fcab(2021-5-11)",
            "ip": "117.12.104.162",
            "status": "wait",
            "handle_time": 1620721199e3,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": null,
            "network_mac_all": [
              "00:15:5d:e0:24:d1",
              "00:15:5d:ed:42:c9",
              "00:15:5d:a6:9c:5c",
              "fc:34:97:4a:6c:69",
              "00:50:56:c0:00:01",
              "00:50:56:c0:00:08",
              "00:00:00:00:00:00",
              "00:15:5d:34:84:93",
              "00:15:5d:c2:3e:69",
              "00:15:5d:e7:fe:34",
              "aa:a1:9f:df:ec:a3"
            ]
          }
        ],
        "total": 1
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 1,
        "size": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/application_handler_list").reply((config) => {
    console.dir(config);
    let _response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_a44ff627f69549519e9ceb6dccb2b95b",
            "device_code": "b4e8bdf676bfa679ff308c297d2f6918",
            "device_name": "windows-x64_79f9(2021-4-30)",
            "ip": "111.164.69.5",
            "status": "pass",
            "handle_time": 1619751776e3,
            "applicant": "\u6D69\u7136 (0088)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "d0:94:66:f4:04:69",
              "00:00:00:00:00:00",
              ""
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_bdaa09c13bcd4a849ad372799d02843c",
            "device_code": "154c33085795cd39bad3f6b94d99355d",
            "device_name": "windows-x64_25a3(2021-4-29)",
            "ip": "117.14.119.127",
            "status": "pass",
            "handle_time": 1619678787e3,
            "applicant": "\u5458\u5DE571 (0071)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_c9e6c355e3964379bedcb15375c68c62",
            "device_code": "154c33085795cd39bad3f6b94d99355d",
            "device_name": "windows-x64_25a3(2021-4-29)",
            "ip": "117.14.119.127",
            "status": "pass",
            "handle_time": 1619678744e3,
            "applicant": "\u5458\u5DE573 (0073)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_4a8f47bc2a5e47f894e91846705b7842",
            "device_code": "154c33085795cd39bad3f6b94d99355d ",
            "device_name": "windows-x64_25a3(2021-4-29)",
            "ip": "117.14.119.127",
            "status": "pass",
            "handle_time": 1619678596e3,
            "applicant": "\u5458\u5DE575 (0075)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_b821978939a245588459633f7bd50080",
            "device_code": "8c5ff1b6a5c2c05ec432d727b4ed2512",
            "device_name": "darwin-x64_e102(2-8-2021)",
            "ip": "117.14.119.127",
            "status": "pass",
            "handle_time": 1619597314e3,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              ""
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_2ac250b21ddb4679ac87d4cae3888384",
            "device_code": "3304c47a0a8afd36471b8fe168b87e10",
            "device_name": "windows-x64_6936(2021-2-8)",
            "ip": "115.26.4.16",
            "status": "pass",
            "handle_time": 1619573147e3,
            "applicant": "\u738B\u6668 (0089)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "a4:0c:66:03:c6:de"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_6543a5326cdd4a34a21f4536dacc1df5",
            "device_code": "3304c47a0a8afd36471b8fe168b87e10",
            "device_name": "windows-x64_6936(2021-2-8)",
            "ip": "115.26.4.16",
            "status": "pass",
            "handle_time": 1619572976e3,
            "applicant": "\u5458\u5DE576 (0076)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "a4:0c:66:03:c6:de"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_dc424f9496f64a869a9a6a5c877a908d",
            "device_code": "7c5bb4d77f14a69efdfc29f8e50d9ed6",
            "device_name": "windows-x64_fcab(2021-4-26)",
            "ip": "117.14.117.176",
            "status": "pass",
            "handle_time": 1619404464e3,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "fc:34:97:4a:6c:69",
              "02:00:4c:4f:4f:50",
              "00:50:56:c0:00:01",
              "00:50:56:c0:00:08",
              "00:00:00:00:00:00",
              "00:15:5d:b8:cb:41",
              "00:15:5d:80:57:66",
              "00:15:5d:ac:76:e7",
              "00:15:5d:ba:6a:d1",
              "00:15:5d:27:b1:bd",
              "00:15:5d:23:5b:02",
              "e2:e3:32:59:a4:98"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_88b8351b78f246f7a6f5f3f233cbdb7f",
            "device_code": "4220462a2b26d85e2006690c5f91811e",
            "device_name": "windows-x64_fcab(2021-4-25)",
            "ip": "117.14.117.176",
            "status": "pass",
            "handle_time": 1619322075e3,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "00:15:5d:c8:5b:c6",
              "00:15:5d:3f:8b:93",
              "fc:34:97:4a:6c:69",
              "02:00:4c:4f:4f:50",
              "00:50:56:c0:00:01",
              "00:50:56:c0:00:08",
              "00:00:00:00:00:00",
              "00:15:5d:60:46:89",
              "00:15:5d:76:db:dd",
              "00:15:5d:ef:d6:9e",
              "00:15:5d:71:0e:68",
              "7c:50:79:76:14:1f",
              "e2:02:55:96:15:f7"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "handle_a55cc101d2a4484781856177529cde6a",
            "device_code": "7ba5e50cdaf56da001528034fad5e2fc",
            "device_name": "windows-x64_8c55(2021-4-8)",
            "ip": "60.25.154.34",
            "status": "pass",
            "handle_time": 1618479857e3,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": {
              "model": "authorize.method",
              "method": "\u6C38\u4E45\u6388\u6743",
              "time_limit": "\u4E0D\u9650\u65F6"
            },
            "network_mac_all": [
              "00:e1:7c:68:41:3d"
            ]
          }
        ],
        "total": 10
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 25,
        "size": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/application_handler_log_list").reply((config) => {
    let _response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "authorize.application.detail",
            "application_guid": "history_7be83737bdfb40d589bdbd6e5a18446d",
            "device_code": "154c33085795cd39bad3f6b94d99355d",
            "device_name": "windows-x64_25a3(2021-1-25)",
            "ip": "125.36.51.83",
            "status": "refuse",
            "handle_time": 161672596e4,
            "applicant": "\u5458\u5DE576 (0076)",
            "marks": [],
            "authorize_method": null,
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_026a517a658445dbad423c7d8689bc55",
            "device_code": "154c33085795cd39bad3f6b94d99355d",
            "device_name": "windows-x64_25a3(2021-1-25)",
            "ip": "125.36.50.24",
            "status": "refuse",
            "handle_time": 1615274939e3,
            "applicant": "\u5458\u5DE576 (0076)",
            "marks": [],
            "authorize_method": null,
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_8b230c75457a4e75b0ca3d1cc1c0a479",
            "device_code": "154c33085795cd39bad3f6b94d99355d",
            "device_name": "windows-x64_25a3(2021-1-25)",
            "ip": "218.68.75.8",
            "status": "refuse",
            "handle_time": 1615186985e3,
            "applicant": "\u5458\u5DE576 (0076)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": null,
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_1da9fb9a757047a5a79b264e9a97b383",
            "device_code": "9d2e36f52c3223402ef1feec832ac7ae",
            "device_name": "windows-x64_fcab(2021-5-11)",
            "ip": "125.36.49.194",
            "status": "refuse",
            "handle_time": 1611645622e3,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [],
            "authorize_method": null,
            "network_mac_all": [
              ""
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_cdbd994e75154e7593b87560d976218a",
            "device _code": "9360fd25ea6efaf1b77d39d4155a79d0",
            "device_name": "apple-x64_7616(2020-10-20)",
            "ip": "60.26.244.117",
            "status": "refuse",
            "handle_time": 1605167052e3,
            "applicant": "\u7565\u7565\u7565123 (0019)",
            "marks": [],
            "authorize_method": null,
            "network_mac_all": [
              ""
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_344aed96fa504560946a692d2a2873e6",
            "device_code": "9360fd25ea6efaf1b77d39d4155a79d0",
            "device_name": "apple-x64_7616(2020-10-20)",
            "ip": "60.26.244.117",
            "status": "refuse",
            "handle_time": 1604999095e3,
            "applicant": "\u7565\u7565\u7565123 (0019)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": null,
            "network_mac_all": [
              ""
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_10cc6f783e3542368f1402ca5f866902",
            "device_code": "d20bceb98dcd78957620fe54828575a0",
            "device_name": "windows-x64_fcab(2021-5-11)",
            "ip": "60.25.177.1",
            "status": "refuse",
            "handle_time": 160220576e4,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [],
            "authorize_method": null,
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_d9dfae89744a4b89867f6b12a04abd30",
            "device_code": "d20bceb98dcd78957620fe54828575a0",
            "device_name": "windows-ia32_6acc(2020-9-28)",
            "ip": "60.25.177.1",
            "status": "refuse",
            "handle_time": 1602203624e3,
            "applicant": "\u5458\u5DE5772321321322312115605615030330020320323220312320 (0077)",
            "marks": [],
            "authorize_method": null,
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_bf031c3c7c1648298ce435c23d780981",
            "device_code": "d20bceb98dcd78957620fe54828575a0",
            "device_name": "windows-ia32_6acc(2020-9-28)",
            "ip": "60.25.177.1",
            "status": "refuse",
            "handle_time": 1601382864e3,
            "applicant": "\u5458\u5DE5772321321322312115605615030330020320323220312320 (0077)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": null,
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          },
          {
            "model": "authorize.application.detail",
            "application_guid": "history_4bba6c5c55b94e65b687fe072bf7e93a",
            "device_code": "d20bceb98dcd78957620fe54828575a0",
            "device_name": "windows-x64_fcab(2021-5-11)",
            "ip": "60.25.177.1",
            "status": "refuse",
            "handle_time": 1601382154e3,
            "applicant": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641 (0079)",
            "marks": [
              "ALLOW_EDIT_APPLICATION"
            ],
            "authorize_method": null,
            "network_mac_all": [
              "a4:0c:66:04:c1:6d"
            ]
          }
        ],
        "total": 10
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 10,
        "size": 10
      }
    };
    return [200, _response];
  });
};
